import { ItemList } from '../orm'

class PhotographerList extends ItemList {
    getEntityKey() {
        return "photographer/photographer"
    }
    
}

export const getInitials = (name) => {
    if (!name) return "?"
    const parts = name.trim().split(" ")
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    }
    return name.substring(0, 2).toUpperCase()
}

export const photographerList = new PhotographerList("photographer_default")
